import "./App.css";
import "./lib/auth"; // Register axios auth interceptors (token injection + 401 redirect)
import { applyTheme, getStoredTheme } from "./lib/brandConfig";

// Apply saved theme immediately on load (before first render)
applyTheme(getStoredTheme());
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AppShell from "./pages/AppShell";
import QuoteEditor from "./pages/QuoteEditor";
import InvoiceEditor from "./pages/InvoiceEditor";
import ProposalEditor from "./pages/ProposalEditor";
import LoginPage from "./pages/LoginPage";
import ClientDetail from "./pages/ClientDetail";
import ContactDetail from "./pages/ContactDetail";
import ProjectDetail from "./pages/ProjectDetail";
import RouteGuard from "./components/RouteGuard";
import ErrorBoundary from "./components/ErrorBoundary";

function App() {
  return (
    <ErrorBoundary>
    <BrowserRouter>
      <Routes>
        {/* Public route — no auth required */}
        <Route path="/login" element={<LoginPage />} />

        {/* Protected routes — RouteGuard wraps each */}
        <Route path="/" element={<RouteGuard><AppShell /></RouteGuard>} />

        {/* Client / Contact / Project detail routes */}
        <Route path="/clients/:id" element={<RouteGuard><ClientDetail /></RouteGuard>} />
        <Route path="/contacts/:id" element={<RouteGuard><ContactDetail /></RouteGuard>} />
        <Route path="/projects/:id" element={<RouteGuard><ProjectDetail /></RouteGuard>} />
        <Route path="/projects/:id/schedule" element={<RouteGuard><ProjectDetail /></RouteGuard>} />
        <Route path="/projects/:id/calendar" element={<RouteGuard><ProjectDetail /></RouteGuard>} />

        {/* Document editors */}
        <Route path="/quote/new" element={<RouteGuard><QuoteEditor /></RouteGuard>} />
        <Route path="/quote/:id" element={<RouteGuard><QuoteEditor /></RouteGuard>} />
        <Route path="/invoice/new" element={<RouteGuard><InvoiceEditor /></RouteGuard>} />
        <Route path="/invoice/:id" element={<RouteGuard><InvoiceEditor /></RouteGuard>} />
        <Route path="/proposal/new" element={<RouteGuard><ProposalEditor /></RouteGuard>} />
        <Route path="/proposal/:id" element={<RouteGuard><ProposalEditor /></RouteGuard>} />

        {/* 404 fallback (L-05) */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
    </ErrorBoundary>
  );
}

/** 404 Not Found page (L-05) */
function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: '#e5e4df' }}>
      <div className="bg-[#f8f7f4] rounded-lg shadow-xl p-12 text-center max-w-[400px]">
        <h2 className="text-xl font-semibold text-[#1a1a2e] mb-2" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
          404 — Page Not Found
        </h2>
        <p className="text-[#6b7280] text-sm mb-4">The page you're looking for doesn't exist.</p>
        <a href="/" className="text-[#0f172a] underline text-sm hover:text-[#c9a84c]">
          Return to Dashboard
        </a>
      </div>
    </div>
  );
}

export default App;
